<div class="search-container" id="search_inner">

  <div class="search_inner">
    <input class="form-control" type="text" name="search" placeholder="Search" tabindex="1" (keyup.enter)="onEnter()"
      [(ngModel)]="searchString" (ngModelChange)="queryChanged($event)">
      @if (!isESignature) {
        <button class="head_search_ico" type="submit" (click)="addClass('expand_search')"><i
        class="header_search"></i></button>
      }
      <div class="search-suggestion">
        @for (data of searchResultsFacWise; track data) {
          <ul>
            <li>
              <h4><i class="fas fa-lock"></i> Customers</h4>
              <div>
                <h6 style="background-color: #3757C5; color: #fff;">{{data.facName}}</h6>
                @if (data.resultSetRented.length) {
                  <span style="color: green;padding-left: 10px;"> Rented</span>
                }
                @for (item of data.resultSetRented; track item) {
                  <ul>
                    <li>
                      <ul>
                        <li (click)="routeToCustomer(item, 1)">
                          <span highlighter [target]="item.searchResult" [searchText]="searchString"></span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                }
                @if (data.resultSetMovedOut.length) {
                  <span style="color: red;padding-left: 10px;"> Moved Out</span>
                }
                @for (item of data.resultSetMovedOut; track item) {
                  <ul>
                    <li>
                      <ul>
                        <li (click)="routeToCustomer(item, 1)">
                          <span highlighter [target]="item.searchResult" [searchText]="searchString"></span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                }
                @if (searchComplete | async) {
                  <ul>
                    <div class="searchContainer">
                      <div id="Searchloader"></div>
                    </div>
                  </ul>
                }
                @if (!searchResults.RentalModel.length && isRecordsEmpty) {
                  <ul>
                    <li>No records found</li>
                  </ul>
                }
              </div>
            </li>
            <li>
              <h4><i class="far fa-hourglass"></i> Reservation</h4>
              <h6 style="background-color: #3757C5; color: #fff;">{{data.facName}}</h6>
              @if (data.resultSetResNew.length) {
                <span style="color: green;padding-left: 10px;"> New Reservation</span>
              }
              @for (item of data.resultSetResNew; track item) {
                <ul>
                  <li (click)="routeToCustomer(item, 2)">
                    <span highlighter [target]="item.searchResult" [searchText]="searchString"></span>
                  </li>
                </ul>
              }
              @if (data.resultSetResConfirmed.length) {
                <span style="color: green;padding-left: 10px;"> Confirmed</span>
              }
              @for (item of data.resultSetResConfirmed; track item) {
                <ul>
                  <li (click)="routeToCustomer(item, 2)">
                    <span highlighter [target]="item.searchResult" [searchText]="searchString"></span>
                  </li>
                </ul>
              }
              @if (data.resultSetResPending.length) {
                <span style="color: green;padding-left: 10px;"> Pending</span>
              }
              @for (item of data.resultSetResPending; track item) {
                <ul>
                  <li (click)="routeToCustomer(item, 2)">
                    <span highlighter [target]="item.searchResult" [searchText]="searchString"></span>
                  </li>
                </ul>
              }
              @if (data.resultSetResCancelled.length) {
                <span style="color: red;padding-left: 10px;"> Cancelled</span>
              }
              @for (item of data.resultSetResCancelled; track item) {
                <ul>
                  <li (click)="routeToCustomer(item, 2)">
                    <span highlighter [target]="item.searchResult" [searchText]="searchString"></span>
                  </li>
                </ul>
              }
              @if (data.resultSetResExpired.length) {
                <span style="color: red;padding-left: 10px;"> Expired</span>
              }
              @for (item of data.resultSetResExpired; track item) {
                <ul>
                  <li (click)="routeToCustomer(item, 2)">
                    <span highlighter [target]="item.searchResult" [searchText]="searchString"></span>
                  </li>
                </ul>
              }
              @if (searchComplete | async) {
                <ul>
                  <div class="searchContainer">
                    <div id="Searchloader"></div>
                  </div>
                </ul>
              }
              @if (!searchResults.ReservationModel.length && isRecordsEmpty) {
                <ul>
                  <li>No records found</li>
                </ul>
              }
            </li>
            <li>
              <h4><i class="far fa-user"></i> Prospects</h4>
              <h6 style="background-color: #3757C5; color: #fff;">{{data.facName}}</h6>
              @if (data.resultSetInqOpen.length) {
                <span style="color: green;padding-left: 10px;"> Open</span>
              }
              @for (item of data.resultSetInqOpen; track item) {
                <ul>
                  <li (click)="routeToCustomer(item, 3)">
                    <span highlighter [target]="item.searchResult" [searchText]="searchString"></span>
                  </li>
                </ul>
              }
              @if (data.resultSetInqConfirmed.length) {
                <span style="color: green;padding-left: 10px;"> Confirmed</span>
              }
              @for (item of data.resultSetInqConfirmed; track item) {
                <ul>
                  <li (click)="routeToCustomer(item, 3)">
                    <span highlighter [target]="item.searchResult" [searchText]="searchString"></span>
                  </li>
                </ul>
              }
              @if (data.resultSetInqPending.length) {
                <span style="color: green;padding-left: 10px;"> Pending</span>
              }
              @for (item of data.resultSetInqPending; track item) {
                <ul>
                  <li (click)="routeToCustomer(item, 3)">
                    <span highlighter [target]="item.searchResult" [searchText]="searchString"></span>
                  </li>
                </ul>
              }
              @if (data.resultSetInqClosed.length) {
                <span style="color:red;padding-left: 10px;"> Closed</span>
              }
              @for (item of data.resultSetInqClosed; track item) {
                <ul>
                  <li (click)="routeToCustomer(item, 3)">
                    <span highlighter [target]="item.searchResult" [searchText]="searchString"></span>
                  </li>
                </ul>
              }
              @if (data.resultSetInqCancelled.length) {
                <span style="color:red;padding-left: 10px;"> Cancelled</span>
              }
              @for (item of data.resultSetInqCancelled; track item) {
                <ul>
                  <li (click)="routeToCustomer(item, 3)">
                    <span highlighter [target]="item.searchResult" [searchText]="searchString"></span>
                  </li>
                </ul>
              }
              @if (searchComplete | async) {
                <ul>
                  <div class="searchContainer">
                    <div id="Searchloader"></div>
                  </div>
                </ul>
              }
              @if (!searchResults.ProspectModel.length && isRecordsEmpty) {
                <ul>
                  <li>No records found</li>
                </ul>
              }
            </li>
          </ul>
        }
        @if (searchComplete | async) {
          <ul>
            <div class="searchContainer">
              <div id="Searchloader"></div>
            </div>
          </ul>
        }
        @if (searchResultsFacWise.length == 0  && isRecordsEmpty) {
          <ul>
            <li style="text-align: center;">No records to display</li>
          </ul>
        }
      </div>
    </div>
    <div class="close_search" (click)="removeClass('expand_search')"></div>


  </div>

  <ng-template #templateConfirm>

    <div class="modal-header">
      <h5 class="modal-title">Confirm</h5>
      <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef1.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body ptb24">
      <div class="row mx-0">
        The record you are trying to access is from a different location. Do you wish to proceed?
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-primary me-3" type="button" (click)="modalRef1.hide()">No</button>
      <button class="btn btn-primary" type="button" (click)="proceedRouteDifferentStore()">Yes</button>

    </div>
  </ng-template>